/**
 * @owner @Appboy/whats-app
 * WhatsApp Message GET Schema (before whats_app_message_type selection)
 */

import { z } from "zod";
import { messageGetBaseSchema } from "@schemas/message/messageGetBaseSchema";
import { whatsAppMessagingServiceSchema } from "@schemas/message/whatsAppMessagingServiceSchema";

export const whatsAppEmptyMessageGetSchema = z.object({
  ...messageGetBaseSchema.shape,
  message_type: z.literal("whatsApp"),
  whats_app_message_type: z.undefined().optional(),
  selected_messaging_service: whatsAppMessagingServiceSchema,
});
